import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87298c58"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-page-number-2',
  props: {
    isDetail: { type: Boolean, default: false },
    pageNo: { default: '01' }
  },
  setup(__props: any) {

const props = __props;

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 48.551 65.85">
    <g id="yema2" transform="translate(-975.449 -2.001)">
      <path id="路径_5242" data-name="路径 5242" d="M-694.086,731.511l-19.1-7.866a1.544,1.544,0,0,0-1.179,0l-19.1,7.866a3.323,3.323,0,0,1-4.59-3.073v-59.2a3.324,3.324,0,0,1,3.324-3.324h41.9a3.324,3.324,0,0,1,3.324,3.324v59.2A3.323,3.323,0,0,1-694.086,731.511Z" transform="translate(1713.496 -663.914)" fill="var(--theme-color-1)"/>
      <text id="_01" data-name="01" transform="translate(983.449 46)" fill="#fff" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
    </g>
  </svg>
`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["svg-block", !_ctx.isDetail && 'isDetail']),
    innerHTML: svg.value
  }, null, 10, _hoisted_1))
}
}

})